import { cn } from '~/lib/cn';
import { variants } from '~/lib/variants';

export const breadcrumbs = variants({
  slots: {
    root: cn(
      'flex min-h-[1.5rem] items-center justify-start space-x-sm self-stretch text-body-sm text-subtle',
    ),
    item: cn('break-all'),
    itemText: '',
    itemLink: '',
  },
  variants: {
    variant: {
      ADA: {
        itemText: cn('text-default'),
      },
      WMG: {
        root: cn('text-body-xs'),
        item: cn('text-default'),
        itemLink: cn('font-semibold underline duration-300 hover:text-hover'),
      },
    },
  },
});
